<template>
  <!-- v-bind:style="{ height: `${tHeight}px`, position: 'fixed', 'max-width': '16.2%', 'overflow-y': 'scroll', }" -->
  <div class="row">
    <div class="col-10" id="dbg-other-stuff-col">
      <div
        id="div-row-core-addr-blank"
      >
        <div class="d-flex flex-row" align-h="between">
          <div class="py-0">
            <div id="b-col-coi-core-table-c">
              <coi-core-item
                :customerOrder="customerOrder"
              />
            </div>
          </div>
          <div class="pb-2 pt-0 pl-2">
            <coi-address-table
              :address="customerOrder.address"
              :countries="countries"
              :customerOrderId="customerOrder.id"
              @mutatedAddress="mutatedAddress"
            />
          </div>
          <div class="py-2 ml-auto">
            <b-row>
              <b-col  class="d-flex">
                <div>
                  <div class="dropdown">
                    <b-overlay
                      id="overlay-background-dropdown"
                      :show="setOrderStateInProgress"
                      spinner-type="grow"
                      rounded="sm"
                      spinner-small
                      ><!-- overlay -->
                      <b-dropdown
                        id="dropdown-order-state"
                        style="background-color: white"
                        variant="outline-secondary"
                        block size="sm"
                        :text="labelOrderState"
                        :disabled="!(this.authorization.shipping_manager || this.authorization.account_assistant)"
                        ><!-- dropdown -->
                        <!--  unicode colored circles 🔴🟠🟡🟢🔵🟣⚫⚪🟤 -->
                        <b-dropdown-item
                          @click="customerOrderStateSelectPrompt(-1)"
                          :active="-1 == customerOrder.orderState"
                          >⚪ Offen</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="customerOrderStateSelectPrompt(0)"
                          :active="0 == customerOrder.orderState"
                          >⚫ Neu</b-dropdown-item
                        >
												<b-dropdown-item
														@click="customerOrderStateSelectPrompt(5)"
														:active="5 == customerOrder.orderState"
												>🔵 In Bearbeitung</b-dropdown-item
												>
                        <b-dropdown-item
                          @click="customerOrderStateSelectPrompt(1)"
                          :active="1 == customerOrder.orderState"
                          >🟢 Erledigt</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="customerOrderStateSelectPrompt(2)"
                          :active="2 == customerOrder.orderState"
                          >🟡 Freigegeben</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="customerOrderStateSelectPrompt(3)"
                          :active="3 == customerOrder.orderState"
                          ><span class="blinker">🔴</span>
                          Erstattet</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click="customerOrderStateSelectPrompt(4)"
                          :active="4 == customerOrder.orderState"
                          >🔴 Erstattet</b-dropdown-item
                        >
                      </b-dropdown>
                    </b-overlay>
                    <b-modal
                      v-model="modalStateChangeOrderState"
                      id="modal-master-change-state"
                      title="Order-Status ändern"
                      @ok="customerOrderStateSelect()"
                      cancel-title="abbrechen"
                      size="md"
                      ><!-- modal -->
                      {{ orderStateChangePrompt }}
                    </b-modal>
                  </div>
                  <div v-if="labelTracking" class="py-2 flex-grow-1">
                    <span v-if="labelTracking.shippingId"
                      >{{ labelTracking.name }}:
                    </span>
                    <a
                      v-if="labelTracking.url"
                      @click="openInNewTab(labelTracking.url)"
                      class="fake-href"
                      >{{ labelTracking.shippingId }}</a
                    >
                    <span v-else>{{ labelTracking.shippingId }}</span>
                    <b-button
                      v-if="labelTracking.shippingId"
                      @click="copyTrackingId()"
                      size="sm"
                      class="py-0 px-1"
                      variant="outline-primary"
                      ><span style="font-size: x-large">🗎</span></b-button
                    >
                  </div>
                  <h4 v-if="customerOrder.postalReturnAt != null" class="text-danger">Postrückläufer {{moment(customerOrder.postalReturnAt).locale("de").format('L')}}</h4>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>

        <div>
            <div class="row" id="b-row-coi-history-c">
                <coi-history
                  :customerOrder="customerOrder"
                  :orderStates="orderStates"
                  @mutatedCustomerOrder="mutatedCustomerOrder"
                />
            </div>
            <div class="row" id="b-row-coi-article-data-c">
                <coi-article-data 
                    :customerOrder="customerOrder"
                    :vendors="vendors"
                    :authorization="authorization"
                ></coi-article-data>
            </div>
        </div>
   </div>
        <div
            class="col-2"
            id="dbg-action-bar-col"
        ><!-- div -->
            <coi-action-bar
                :customerOrder="customerOrder"
                :orderStates="orderStates"
                :vendors="vendors"
                :marketAccounts="marketAccounts"
                @mutatedStock="mutatedStock"
                @mutatedOrderState="mutatedOrderState"
								@mutatedCustomerOrder="mutatedCustomerOrder"
								@mutatedCustomerOrderItemDelivery="mutatedCustomerOrderItemDelivery"
                :authorization="authorization"
             />
        </div>
    </div>
</template>
<style>
	.blinker {
	   animation: blinkerkeyframe 1s linear infinite;
	}
	@keyframes blinkerkeyframe {
	50% { opacity: 0; }
	}
   .fake-href {
      cursor:pointer !important;
      color:rgb(52,144,220) !important;
   }
   .fake-href:hover {
      text-decoration:underline!important;
   }
  .number-box {
    padding: 5px 10px;
    border-radius: 50%;
    text-align: center;
    font-size: 1em;
    border: 2px solid transparent; /* Default border */
  }
  .border-danger {
    border-color: red;
    background-color: red;
  }
  .border-success {
    border-color: green;
    background-color: green;
  }
</style>
<script>
export default {
   props: [
      'authorization',
      'countries',
      'customerOrder',
      'marketAccounts',
      'orderStates',
      'vendors',
   ],
   data() {
      return {
           blink: true
         , modalStateChangeOrderState: false
         , selectedOrderState: null
         , setOrderStateInProgress: false
         , shippingServices: null
      }
   },
   computed: {
      orderStateChangePrompt: function() {
         const from = this.orderStates.types[this.customerOrder.orderState];
         const to = this.orderStates.types[this.selectedOrderState];
         return `Wollen Sie den Order-Status wirklich »${from} → ${to}« ändern?`;
      },
      labelOrderState()
      {
         switch(this.customerOrder.orderState)
         {
            case this.orderStates.codes.OPEN: return "⚪ Offen";
            case this.orderStates.codes.NEW:  return "⚫ Neu";
            case this.orderStates.codes.DONE: return "🟢 Erledigt";
            case this.orderStates.codes.WAIT: return "🟡 Freigegeben";
            case this.orderStates.codes.REFUND: return `${(this.blink)? '🔴':'⚪'} Erstattet`;
					  case this.orderStates.codes.REFUND_OK: return "🔴 Erstattet";
					  case this.orderStates.codes.IN_PROGRESS: return "🔵 In Bearbeitung";
            default: return "???";
         }
      },
      labelTracking() {
         if(this.shippingServices == null) return { name: '', url: null, shippingId: null};

         const coi = this.customerOrder.customerorderitems;
         const coida = coi[0].customerorderitemdeliveryaddition;

         if( !coi || !coi[0] || !coida ) return { name: '', url: null, shippingId: null};

        let shippingService = this.shippingServices.find(
          (x) => x.id == coida.shippingService
        );
        if (shippingService &&
          shippingService.url &&
          !shippingService.url.includes("%IDENTIFIER%")
        ) {
          this.$bvToast.toast(
            `Shipping Service (für B-Nr. ${this.customerOrder.id}) URL enthaelt nicht den Sub-String '%IDENTIFIER%', bitte diesen in die shipping_service Tabelle nachtragen!`,
            {
              title: "Customer Order Index",
              noAutoHide: true,
              appendToast: false,
              variant: "danger",
            }
          );
        }

        if(shippingService){

          let tempUrl = (!shippingService.url) ? null : shippingService.url.replace('%IDENTIFIER%', coida.shippingId );

          if(this.isShippingToNLorBE(shippingService)){
            tempUrl = this.shippingServices.find(
              (x) => x.id == 30 // id 30 = POSTNL Letterbox PLus
            ).url.replace('%IDENTIFIER%', coida.shippingId );
          }

          if(tempUrl){
            tempUrl = (tempUrl.includes('%ZIPCODE%')) ? tempUrl.replace( '%ZIPCODE%', this.customerOrder.address.zipCode ):  tempUrl;
            tempUrl = (tempUrl.includes('%COUNTRYISO%')) ? tempUrl.replace( '%COUNTRYISO%', this.customerOrder.address.country.countryIso ) :  tempUrl;
          }

          return {
            name: shippingService.name,
            url: tempUrl,
            shippingId: coida.shippingId
          };
        }

        return { name: '', url: '#', shippingId: coida.shippingId };
      },

   },
   methods: {
      mutatedStock(newStock) {
         newStock.material = _.cloneDeep(this.customerOrder.customerorderitems[0].stock.material);
         this.customerOrder.customerorderitems[0].stock = newStock;
      },
      // @param: {customerOrderId:number, rawAddress:object }
      mutatedAddress(hollow) {
         this.customerOrder.address = hollow.rawAddress;
         this.$emit( 'mutatedAddress', hollow ); // passthrough to root Component
      },
      mutatedCustomerOrder(newCustomerOrder) {
         this.$emit('mutatedCustomerOrder', newCustomerOrder);
      },
      mutatedCustomerOrderItemDelivery(newCustomerOrderItemDelivery) {
         this.customerOrder.customerorderitems[0].customerorderitemdeliveries = newCustomerOrderItemDelivery;
      },
      mutatedOrderState(newOrderState) {
         this.customerOrder.orderState = newOrderState;
         this.$emit('mutatedCustomerOrder', this.customerOrder);
      },
      customerOrderStateSelectPrompt(newOrderState) {
         if((newOrderState == this.customerOrder.orderState)
         || ([this.orderStates.codes.REFUND, this.orderStates.codes.REFUND_OK].includes(newOrderState))
         ) {
            alert("In diesen Zustand darf nicht gewechselt werden.");
            return;
         }
         this.selectedOrderState = newOrderState;
         this.modalStateChangeOrderState = true;
      },
      customerOrderStateSelect()
      {
         this.modalStateChangeOrderState = false;
         console.log("called customerOrderState select");
         let payload = {
            orderState: this.selectedOrderState,
            customerOrderId: this.customerOrder.id
         }
         this.setOrderStateInProgress = true;
         // guarantees a minium delay of 500ms or longer, if request takes longer. The animation looks very consistent thereby.
         //NICE very cool trick, gotta remember this one
         Promise.all([
            axios.post('/customerorder/action/changeorderstate', payload),
            new Promise(r => setTimeout(r, 500))
         ]).then( () => {
            this.customerOrder.orderState = this.selectedOrderState;
            this.selectedOrderState = null;
            this.setOrderStateInProgress = false;
            this.$emit('mutated', this.customerOrder.orderState);
         }).catch( error => {
            alert("konnte Status nicht ändern");
            console.error(error);
         });
      },
      openInNewTab(url)
      {
         var win = window.open(url, "_blank");
         win.focus();
      },
      copyTrackingId()
      {
        console.log("+++copyTrackingId");
        const el = document.createElement('textarea');
        el.value = this.labelTracking.shippingId;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        this.alertMessage = `TrackingId "${this.labelTracking.shippingId}" wurde in die Zwischenablage gelegt.`
        document.body.removeChild(el);
        this.$bvToast.toast( this.alertMessage, {
            title: 'Copy To Clipboard',
            autoHideDelay: 1000,
            appendToast: false
        });
      },
      isShippingToNLorBE(shippingService){
          return shippingService.id == 11 &&
              ( this.customerOrder.address.country.countryIso == 'NL' || this.customerOrder.address.country.countryIso == 'BE' );
      },
			 formatDate(s) {
				 //console.log("Format date called with: " + s);
				 const result = (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '‒';
				 //console.log(result)
				 return result;
			 },
   },
   created() {
      setInterval(() => { this.blink = !this.blink; }, 1000); //TODO reimplement this in CSS

      axios.get("/shipping_service/all").then( response => {
         this.shippingServices = response.data;
      });

			 if(this.customerOrder
					 && this.customerOrder.orderlog
					 && this.customerOrder.orderlog.length > 0
					 && this.customerOrder.orderlog[this.customerOrder.orderlog.length - 1].deliverynoteposition
					 && this.customerOrder.orderlog[this.customerOrder.orderlog.length - 1].deliverynoteposition.deliverynote.dateCompleted == null)
			 {

				 this.customerOrder.maybeInboundShipmentDate = this.formatDate(this.customerOrder.orderlog[this.customerOrder.orderlog.length - 1].deliverynoteposition.deliverynote.date);
			 }
   },
}
</script>
